class FormAddressManager {
  constructor (recipients) {
    this.recipients = recipients
  }

  getField (
    defaultValues,
    fields = [
      'city',
      'country',
      'neighborhood',
      'zip_code',
      'street',
      'complement',
      'number'
    ]
  ) {
    const values = fields.reduce(
      (acc, fieldName) => ({
        ...acc,
        [fieldName]: this.recipients?.location?.address?.[fieldName]
      }),
      {}
    )

    return {
      ...defaultValues,
      initialValues: values,
      fields
    }
  }
}

export default FormAddressManager
